import fileDownload from 'js-file-download'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
import moment from 'moment'

export class KpiRoseService extends BaseService {
  static async getList(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.manage-device-filter'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async uploadFile(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-device.import-excel'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadErrorFile(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.manage-device-kpi.download-file-error-import'),
        body,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(
        response.data,
        'File lỗi hoa hồng' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadDataToFile(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.manage-device-kpi.download-file-error-import'),
        body,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(
        response.data,
        'File lỗi hoa hồng' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async dowTemplate(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.manage-device-kpi.download-file-template'),
        body,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(
        response.data,
        'File mẫu hoa hồng' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
